import { computed } from 'vue'

export function useWalletHolders(holdersRef) {
  // holdersRef: Ref<Array>
  const holderSet = computed(() => {
    const arr = holdersRef?.value || []
    return new Set(arr.map(h => String(h?.address || h?.owner || '').trim()).filter(Boolean))
  })

  const holderAmountMap = computed(() => {
    const arr = holdersRef?.value || []
    const map = {}
    for (const h of arr) {
      const pk = String(h?.address || h?.owner || '').trim()
      if (!pk) continue
      const n = Number(h?.amount || 0)
      if (!Number.isFinite(n) || n <= 0) continue
      map[pk] = n
    }
    return map
  })

  function holderAmount(pk = '') {
    pk = String(pk || '').trim()
    if (!pk) return 0
    return holderAmountMap.value[pk] || 0
  }

  function statusClassForWallet(pk = '', devWallet = '') {
    pk = String(pk || '').trim()
    const dev = String(devWallet || '').trim()
    if (!pk) return 'off'

    const isHold = holderSet.value.has(pk)
    const isDev = dev && pk === dev

    if (isDev && !isHold) return 'dev-gold'
    if (isHold) return 'on'
    return 'off'
  }

  return {
    holderSet,
    holderAmountMap,
    holderAmount,
    statusClassForWallet,
  }
}
